import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import VideoPlayer from "../components/VideoPlayer";
import { FaGithub } from "react-icons/fa";
import { ImageSliderProjects } from "../components/ImageSliderProjects";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import "animate.css";
import "../css/ProjectDetails.css";

const Project_Details = () => {
  const { id } = useParams();
  const [project, setProject] = useState(null);

  useEffect(() => {
    async function fetchProject() {
      try {
        const projectRef = doc(db, "projects", id);
        const projectSnap = await getDoc(projectRef);
        if (projectSnap.exists()) {
          setProject(projectSnap.data());
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchProject();
  }, [id]);

  if (!project) return <div>Loading...</div>;

  return (
    <Container style={{ marginTop: "110px",paddingTop:"20px",borderTop:"1px solid white" }} className="projectDetails-start">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "80%",
          marginBottom: "30px",
        }}
        className="projectDetailsName"
      >
        <h1 style={{ fontWeight: "900",color:"orange" }}>{project.projectName}</h1>

        <div>
          <a href={project.projectGitLink} target="_blank">
            <button className="hover-button">
              <FaGithub style={{ marginRight: "0.5rem", fontSize: "2rem" }} />
              <span style={{fontWeight:"800"}}>Github Link</span>
            </button>
          </a>
        </div>
      </div>

      <Col size={12}>
        <Tab.Container id="projectDetails-tabs" defaultActiveKey="screenshots">
          <div className="projectDetails-full-div" style={{ gap: "30px" }}>
            <div className="projectDetails-cat-nav">
              <Nav
                variant="pills"
                id="pills-tab"
                // className="projectDetails-category-grid"
                // style={{ backgroundColor: "blue",display:"flex",flexDirection:"column",width:"200px" }}
              >
                <Nav.Item key="descriptionCat" >
                  <Nav.Link eventKey="description">Description</Nav.Link>
                </Nav.Item>
                <Nav.Item key="screenshotsCat">
                  <Nav.Link eventKey="screenshots">Screenshots</Nav.Link>
                </Nav.Item>
                <Nav.Item key="demoCat" >
                  <Nav.Link eventKey="demo">Demo</Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            <div className="projectDetails-cat-content">
              <Tab.Content id="slideInUp">
                <Tab.Pane eventKey="description" key="descriptionCat">
                  <div className="projectDetails-card-view">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: project.projectDescription,
                      }}
                      style={{lineHeight:"30px" }}
                    />
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="screenshots" key="screenshotsCat">
                  <div className="projectDetails-card-view">
                    <ImageSliderProjects data={project.projectImage} />
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="demo" key="demoCat">
                  <div className="projectDetails-card-view">
                    <VideoPlayer videoLink={project.projectVideo} />
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </Col>
    </Container>
  );
};
export default Project_Details;
{
  /* <div
style={{
  marginTop: "150px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",

}}
>
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "red",
    width: "80%",
    marginBottom:"30px"
  }}
>
  <h1 style={{ fontWeight: "900" }}>{project.projectName}</h1>

  <div>
    <a href={project.projectGitLink} target="_blank">
      <button className="gitBtn">
        <FaGithub style={{ marginRight: "0.5rem", fontSize: "2rem" }} />
        <span>Github Link</span>
      </button>
    </a>
  </div>
</div>
<h2 style={{ color: "#00DD53", fontWeight: "600", fontSize: "40px",textAlign:"left" }}>
  Description
  <br />
</h2>
<p
  dangerouslySetInnerHTML={{ __html: project.projectDescription }}
  style={{ width: "80%", fontSize: "20px" }}
/>

<h2 style={{ color: "#00DD53", fontWeight: "600", fontSize: "40px" }}>
  Project Screenshots
</h2>
<div style={{ width: "70vw" }}>
  <ImageSliderProjects data={project.projectImage} />
</div>

<h2 style={{ color: "#00DD53", fontWeight: "800", fontSize: "50px" }}>
  Project Demo
</h2>
<br />
<VideoPlayer videoLink={project.projectVideo} />
</div> */
}
